
export interface DepartmentSEOContent {
  code: string;
  name: string;
  region: string;
  mainCities: string[];
  seoTitle: string;
  seoDescription: string;
  heroTitle: string;
  heroSubtitle: string;
  services: {
    title: string;
    description: string;
    keywords: string[];
  }[];
  localInfo: {
    population: string;
    economicActivity: string[];
    environmentalChallenges: string[];
  };
  testimonialQuote?: string;
  specificServices: string[];
}

export const departmentSEOContent: Record<string, DepartmentSEOContent> = {
  "12": {
    code: "12",
    name: "Aveyron",
    region: "Occitanie",
    mainCities: ["Rodez", "Millau", "Villefranche-de-Rouergue", "Decazeville", "Saint-Affrique"],
    seoTitle: "Gestion des déchets Aveyron (12) - Groupe Fabre Environnement",
    seoDescription: "Expert en gestion des déchets dans l'Aveyron. Services à Rodez, Millau, Villefranche. Location bennes, recyclage métaux, valorisation déchets.",
    heroTitle: "Votre partenaire environnement dans l'Aveyron",
    heroSubtitle: "Solutions de gestion des déchets à Rodez, Millau et dans tout le département",
    services: [
      {
        title: "Location de bennes Aveyron",
        description: "Bennes de 8m³ à 30m³ pour vos chantiers aveyronnais",
        keywords: ["benne Rodez", "location benne Millau", "conteneur Aveyron"]
      },
      {
        title: "Recyclage métaux Aveyron",
        description: "Rachat de métaux ferreux et non ferreux dans tout l'Aveyron",
        keywords: ["ferraille Rodez", "cuivre Millau", "recyclage métal Aveyron"]
      }
    ],
    localInfo: {
      population: "279 000 habitants",
      economicActivity: ["Agriculture", "Industrie agroalimentaire", "Tourisme", "Métallurgie"],
      environmentalChallenges: ["Gestion des déchets agricoles", "Valorisation des déchets industriels", "Protection du patrimoine naturel"]
    },
    specificServices: ["Collecte déchets agricoles", "Traitement déchets agroalimentaires", "Démolition patrimoine rural"]
  },
  "31": {
    code: "31",
    name: "Haute-Garonne",
    region: "Occitanie",
    mainCities: ["Toulouse", "Muret", "Saint-Gaudens", "Colomiers", "Tournefeuille"],
    seoTitle: "Gestion des déchets Haute-Garonne (31) - Groupe Fabre Environnement",
    seoDescription: "Services de gestion des déchets en Haute-Garonne. Intervention à Toulouse, Muret, Saint-Gaudens. Solutions pour entreprises et particuliers.",
    heroTitle: "Solutions déchets en Haute-Garonne",
    heroSubtitle: "De Toulouse à Saint-Gaudens, votre expert en valorisation des déchets",
    services: [
      {
        title: "Gestion déchets urbains Toulouse",
        description: "Solutions adaptées aux besoins de la métropole toulousaine",
        keywords: ["déchets Toulouse", "benne Muret", "recyclage Colomiers"]
      },
      {
        title: "Services industriels Haute-Garonne",
        description: "Gestion des déchets pour l'industrie aéronautique et technologique",
        keywords: ["déchets industriels Toulouse", "recyclage entreprise 31"]
      }
    ],
    localInfo: {
      population: "1 400 000 habitants",
      economicActivity: ["Aéronautique", "Technologies", "Services", "Recherche"],
      environmentalChallenges: ["Gestion déchets urbains", "Déchets technologiques", "Économie circulaire urbaine"]
    },
    specificServices: ["Collecte déchets technologiques", "Gestion déchets aéronautiques", "Solutions métropole"]
  },
  "81": {
    code: "81",
    name: "Tarn",
    region: "Occitanie", 
    mainCities: ["Albi", "Castres", "Mazamet", "Gaillac", "Lavaur"],
    seoTitle: "Gestion des déchets Tarn (81) - Groupe Fabre Environnement",
    seoDescription: "Expert gestion déchets dans le Tarn. Services à Albi, Castres, Mazamet. Location bennes, recyclage, valorisation pour professionnels et particuliers.",
    heroTitle: "Votre expert déchets dans le Tarn",
    heroSubtitle: "Solutions environnementales d'Albi à Castres",
    services: [
      {
        title: "Location bennes Tarn",
        description: "Service de proximité dans tout le département tarnais",
        keywords: ["benne Albi", "location Castres", "conteneur Mazamet"]
      },
      {
        title: "Recyclage textile Tarn",
        description: "Solutions spécialisées pour l'industrie textile locale",
        keywords: ["déchets textile", "recyclage Castres", "valorisation textile"]
      }
    ],
    localInfo: {
      population: "387 000 habitants",
      economicActivity: ["Textile", "Agroalimentaire", "Tourisme", "Viticulture"],
      environmentalChallenges: ["Déchets textiles", "Valorisation agricole", "Préservation paysages"]
    },
    specificServices: ["Gestion déchets textiles", "Collecte déchets viticoles", "Solutions PME locales"]
  }
};
